import React from "react";
import CanonicalCoursePage, {
  CourseProps,
  getServerSideProps as canonicalGetServerSideProps,
} from "./index";

const CoursePage: React.FC<CourseProps> = props => {
  return <CanonicalCoursePage {...props} />;
};

export default CoursePage;

export const getServerSideProps = canonicalGetServerSideProps;
